<div style="width:100%;">
    <form class="example-form">
        <mat-form-field class="field-full-width">
            <input type="text"
                    placeholder="Chercher"
                    aria-label="medicament"
                    matInput
                    [formControl]="drugSearchControl"
                    [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let drug of filteredDrugs | async" [value]="drug.name" (click)="selectDrug(drug)">
                    <div>
                        <fa-icon *ngIf="drug.key === 'SNItem.CNItem.CNDrug'" [icon]="['fas', 'pills']" class="action-fa-icon" size="lg"></fa-icon>
                        <fa-icon *ngIf="drug.key === 'SNItem.CNItem.CNDrugIngredient'" [icon]="['fas', 'hashtag']" class="action-fa-icon" size="lg"></fa-icon>
                        <span>&nbsp;{{drug.name}}</span>
                    </div>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </form>
</div>
<mat-dialog-content>
    <div style="display: block;overflow: auto;">
        <app-drug-table></app-drug-table>
    </div>
</mat-dialog-content>